import fontawesome from '@fortawesome/fontawesome'
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope'
import faPhone from '@fortawesome/fontawesome-free-solid/faPhone'
import faMapMarkerAlt from '@fortawesome/fontawesome-free-solid/faMapMarkerAlt'
import faFax from '@fortawesome/fontawesome-free-solid/faFax'
import faChevronLeft from '@fortawesome/fontawesome-free-solid/faChevronLeft'
import faChevronRight from '@fortawesome/fontawesome-free-solid/faChevronRight'

export default function () {
  fontawesome.library.add(
    faEnvelope,
    faPhone,
    faMapMarkerAlt,
    faFax,
    faChevronLeft,
    faChevronRight
  )
}



// WEBPACK FOOTER //
// ./scripts/util/fontawesome.js